import React, { useEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import arrowBack from '../../assets/icons/arrow-back.svg';
import arrowBackBlack from '../../assets/icons/arrow-right-black.svg';

const siteId = process.env.REACT_APP_BUILD_SITE;

const isBrasilSite = () => siteId.includes('BR');
const isCMBR = siteId.includes('CMBR');

function Drawer({ children, isOpen, onClose, isDarkBackground, coverAll = false }) {
  useEffect(() => {
    const [body] = document.getElementsByTagName('body');
    body.style.overflow = 'hidden';
    return () => {
      body.style.overflow = 'auto';
    };
  }, []);

  return (
    <DrawerContainer isOpen={isOpen} cover={coverAll}>
      {onClose && (
        <BackButtonContainer isDarkBackground={isDarkBackground}>
          <BackButton isDarkBackground={isDarkBackground} onClick={onClose} data-panel='panel-backButton' />
        </BackButtonContainer>
      )}
      {children}
    </DrawerContainer>
  );
}

const FadeIn = keyframes`
  0% {
    top: 70%;
    opacity: 0;
  }
  100% {
    top: ${isBrasilSite() && !isCMBR ? '90px' : '60px'};
    opacity: 1;
  }
`;

const FadeInCover = keyframes`
  0% {
    top: 70%;
    opacity: 0;
  }
  100% {
    top: 0;
    opacity: 1;
  }
`;

const DrawerContainer = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  background-color: white;
  position: fixed;
  overflow: auto;
  right: 0;
  z-index: ${({ cover }) => (cover ? 1000 : 2)};
  width: 100vw;
  height: 100%;
  animation: ${({ cover }) => (cover ? FadeInCover : FadeIn)} 0.3s ease-in forwards;
  padding-bottom: 80px;
`;

const darkBackgroundStyles = css`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.77) 0%, rgba(0, 0, 0, 0) 100%);
`;

const BackButtonContainer = styled.div`
  position: absolute;
  top: 0;
  height: 40px;
  width: 100%;
  z-index: 2;
  ${({ isDarkBackground }) => isDarkBackground && darkBackgroundStyles}
`;

const BackButton = styled.button`
  background-image: url(${({ isDarkBackground }) => (isDarkBackground ? arrowBack : arrowBackBlack)});
  background-size: cover;
  width: 3rem;
  height: 3rem;
  margin-left: 15px;
  margin-top: 10px;
`;

export default Drawer;
